<template>
  <div>
    <b-navbar
      class="header"
      tag="header"
      fixed="top"
      toggleable="lg"
      variant="white"
    >
      <b-navbar-brand class="mr-5">
        <b-button
          class="d-none d-lg-block sidebar-toggle-btn"
          :class="[isSidebarOpen === true ? 'is-open' : 'is-close']"
          @click="onClickToggleSidebarBtn"
          variant="transparent"
        >
          <img src="../../assets/images/icon-menu.svg" alt="menu" />
        </b-button>
        <img
          class="mr-3 logo-img"
          v-if="!!companyLogo"
          alt
          :src="companyLogo"
        />
        <h1 class="client-title">
          {{ isMyoridge ? $t('Myoridge 生産管理システム') : getCompanyName }}
          <span style="color: red;" v-if="isLocalEnv">
            &nbsp;{{ $t('pageTitle.local') }}
          </span>
          <span style="color: red;" v-if="isDevEnv">
            &nbsp;{{ $t('pageTitle.dev') }}
          </span>
          <span style="color: red;" v-if="isStagingEnv">
            &nbsp;{{ $t('pageTitle.staging') }}
          </span>
        </h1>
      </b-navbar-brand>
      <span
        class="d-inline-flex d-lg-none ml-auto header-right"
        ref="headerRightMd"
      >
        <b-nav class="header-right-md">
          <b-nav-item-dropdown
            right
            variant="link"
            toggle-class="text-decoration-none"
            no-caret
          >
            <template #button-content>
              <img src="../../assets/images/icon-help.svg" alt="help" />
            </template>
            <b-dropdown-item href="https://monorevo.force.com/s/" target="_blank">
              {{ $t('ヘルプセンター') }}
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown
            class="header-info"
            right
            variant="link"
            toggle-class="text-decoration-none"
            no-caret
            ref="infoDropDownMd"
            @shown="onShownInfoDropdown"
          >
            <template #button-content>
              <img src="../../assets/images/icon-info.svg" alt="info" />
              <b-badge v-if="hasNewInfo" pill class="header-info-new">
                NEW
              </b-badge>
            </template>
            <b-dropdown-group :header="$t('お知らせ')">
              <span v-for="(item, index) in info" :key="index">
                <b-dropdown-divider />
                <b-dropdown-text>
                  <p
                    class="header-info-date"
                    :class="item.initial ? 'd-none' : ''"
                  >
                    {{ item.date }}
                  </p>
                  <vue-markdown class="header-info-message">{{
                    item.message
                  }}</vue-markdown>
                </b-dropdown-text>
              </span>
              <span v-if="info == null || info.length === 0">
                <b-dropdown-divider />
                <b-dropdown-text v-if="info == null || info.length === 0">
                  {{ $t('お知らせはありません。') }}
                </b-dropdown-text>
              </span>
            </b-dropdown-group>
          </b-nav-item-dropdown>
        </b-nav>
      </span>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <common-header-purchase-item
          v-if="isUsePurchaseMenu"
          :permissions="permissions"
          :setActivePageClass="setActivePageClass"
          @onClickNavItem="onClickNavItem"
        />
        <common-header-inventory-item
          v-else-if="isUseInventoryMenu"
          :permissions="permissions"
          :setActivePageClass="setActivePageClass"
          @onClickNavItem="onClickNavItem"
        />
        <common-header-smalllot-item
          v-else-if="isUseSmallLotMenu"
          :permissions="permissions"
          :setActivePageClass="setActivePageClass"
          @onClickNavItem="onClickNavItem"
        />
        <common-header-base-item
          v-else-if="isUseBaseMenu"
          :permissions="permissions"
          @onClickNavItem="onClickNavItem"
        />
        <b-navbar-nav class="ml-auto d-none d-lg-inline-flex header-right">
          <b-nav-item-dropdown
            right
            variant="link"
            toggle-class="text-decoration-none"
            no-caret
          >
            <template #button-content>
              <img src="../../assets/images/icon-help.svg" alt="help" />
            </template>
            <b-dropdown-item href="https://monorevo.force.com/s/" target="_blank">
              {{ $t('ヘルプセンター') }}
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown
            class="header-info"
            right
            variant="link"
            toggle-class="text-decoration-none"
            no-caret
            ref="infoDropDown"
            @shown="onShownInfoDropdown"
          >
            <template #button-content>
              <img src="../../assets/images/icon-info.svg" alt="info" />
              <b-badge v-if="hasNewInfo" pill class="header-info-new">
                NEW
              </b-badge>
            </template>
            <b-dropdown-group :header="$t('お知らせ')">
              <span v-for="(item, index) in info" :key="index">
                <b-dropdown-divider />
                <b-dropdown-text>
                  <p
                    class="header-info-date"
                    :class="item.initial ? 'd-none' : ''"
                  >
                    {{ item.date }}
                  </p>
                  <vue-markdown class="header-info-message">{{
                    item.message
                  }}</vue-markdown>
                </b-dropdown-text>
              </span>
              <span v-if="info == null || info.length === 0">
                <b-dropdown-divider />
                <b-dropdown-text v-if="info == null || info.length === 0">
                  {{ $t('お知らせはありません。') }}
                </b-dropdown-text>
              </span>
            </b-dropdown-group>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown
            right
            variant="link"
            toggle-class="text-decoration-none"
            no-caret
          >
            <template #button-content>
              <img
                src="../../assets/images/icon-account-circle.svg"
                alt="Account"
              />
            </template>
            <b-dropdown-group :header="username">
              <b-dropdown-divider />
              <b-dropdown-item :href="changeCardURL">
                {{ $t('カード情報変更') }}
              </b-dropdown-item>
              <b-dropdown-item href="#" @click="onClickChangePassword">
                {{ $t('パスワード変更') }}
              </b-dropdown-item>
              <b-dropdown-item href="#" @click="logout">
                {{ $t('ログアウト') }}
              </b-dropdown-item>
            </b-dropdown-group>
          </b-nav-item-dropdown>
        </b-navbar-nav>
        <b-navbar-nav class="d-lg-none">
          <b-dropdown-divider />
          <b-nav-item :href="changeCardURL">
            {{ $t('カード情報変更') }}
          </b-nav-item>
          <b-nav-item href="#" @click="onClickChangePassword">
            {{ $t('パスワード変更') }}
          </b-nav-item>
          <b-nav-item href="#" @click="logout">
            {{ $t('ログアウト') }}
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <change-password-modal ref="changePasswordModal"></change-password-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import changePasswordModal from '../ChangePasswordModal.vue'

export default {
  components: {
    changePasswordModal,
  },
  data() {
    return {
      /** お知らせ情報 */
      info: [],
      /** カード情報を変更するサイトのURL */
      changeCardURL: '',
    }
  },
  props: {
    /** 会社のロゴを表す画像データ */
    companyLogo: {
      type: String,
      required: false,
    },
    /** サイドバーが展開されているか */
    isSidebarOpen: {
      type: Boolean,
      required: true,
    },
    /** 会社情報 */
    company: {
      type: Object,
      required: true,
    },
    /** サービスの使用権限を取得する関数群 */
    permissions: {
      type: Object,
      required: true,
    },
    /** サービスID */
    serviceID: {
      type: String,
      required: true,
    },
    /** ローカルストレージにロケーションの履歴が存在したか */
    existLocationHistory: {
      type: Boolean,
      required: true,
    },
  },
  async created() {
    this.changeCardURL = await this.getCardURL()
    const sendLoginEvent = () => {
      const cognitoUId = this.userdata.cognitoUId.split('/')
      window.dataLayer?.push({
        event: 'login',
        page_url: window.location.href,
        page_title: document.title,
        login_user_id: cognitoUId[0],
        login_company_id: cognitoUId[1],
        member_id: this.userdata.id,
      })
      localStorage.setItem(
        '__monorevo.login.info',
        JSON.stringify({
          login_user_id: cognitoUId[0],
          login_company_id: cognitoUId[1],
          member_id: this.userdata.id,
          isSendedLoginEvent: true,
        })
      )
    }

    if (localStorage) {
      const loginInfo = localStorage.getItem('__monorevo.login.info')
      if (loginInfo) {
        const login = JSON.parse(loginInfo)
        if (!login.isSendedLoginEvent) {
          sendLoginEvent()
        }
      } else {
        if (this.$appConfig.Env === 'development') {
          alert('need login')
        } else {
          this.logout()
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      username: 'auth/username',
      userdata: 'auth/userdata',
      authorization: 'auth/authorization',
      isMyoridge: 'auth/isMyoridge',
    }),
    isLocalEnv() {
      return window.location.href.includes('localhost')
    },
    isDevEnv() {
      return window.location.href.includes('app-dev.monorevo.jp')
    },
    isStagingEnv() {
      return (
        window.location.href.includes('app-stg.monorevo.jp') ||
        window.location.href.includes('app-protec.monorevo.jp')
      )
    },
    /** 受発注管理サービスのメニューを使用するか。 */
    isUsePurchaseMenu() {
      return this.serviceID === this.$appConfig.serviceID.purchase
    },
    /** 在庫管理サービスのメニューを使用するか。 */
    isUseInventoryMenu() {
      return this.serviceID === this.$appConfig.serviceID.inventory
    },
    /** 工程管理サービスのメニューを使用するか。 */
    isUseSmallLotMenu() {
      return this.serviceID === this.$appConfig.serviceID.smallLot
    },
    /** 各種設定サービスのメニューを使用するか。 */
    isUseBaseMenu() {
      return this.serviceID === this.$appConfig.serviceID.base
    },
    /** 企業名を取得する。 */
    getCompanyName() {
      return this.company?.name
    },
    /** 初回ログイン時に表示する未読のお知らせがあるか。 */
    hasWelcomeInfo() {
      for (const item of this.info) {
        if (item.initial === true && item.readed === null) return true
      }
      return false
    },
    /** 新しいお知らせがあるか。 */
    hasNewInfo() {
      for (const item of this.info) {
        if (item.readed === null) return true
      }
      return false
    },
  },
  watch: {
    /** マスターデータが更新された際の処理。 */
    async company() {
      this.info = await this.getInformation()
    },
    /** 初回ログイン時にドロップダウンを展開する。 */
    info() {
      if (this.hasWelcomeInfo && !this.existLocationHistory) {
        const refEl = this.$refs.headerRightMd
        const styles = window.getComputedStyle(refEl)
        const displayStyle = styles.getPropertyValue('display')
        if (displayStyle === 'none') {
          this.$refs.infoDropDown.show()
        } else {
          this.$refs.infoDropDownMd.show()
        }
      }
    },
  },
  methods: {
    ...mapActions({
      logout: 'auth/logout',
    }),
    /** お知らせ情報を取得する。 */
    async getInformation() {
      var query = `?companyId=${this.company?.id}`
      query += `&userId=${this.userdata?.id}`
      query += `&languageCode=${this.userdata?.languageCode}`
      const info = await this.$axios.get(
        `${this.$appConfig.CommonApiUrl}/info${query}`,
        {
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
        },
      )
      return info?.data
    },
    /** カード情報を変更するサイトのURLを取得する。 */
    async getCardURL() {
      try {
        const res = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/company/card/url`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          },
        )
        return res.data.url
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    },
    /** パスワード変更メニューをクリック時の処理 */
    onClickChangePassword() {
      this.$refs.changePasswordModal.openModal()
    },
    /** サイドバーの表示切替ボタンをクリック時の処理 */
    onClickToggleSidebarBtn() {
      this.$emit('toggleSidebar')
    },
    /** ナビゲーションアイテムをクリック時の処理 */
    onClickNavItem(serviceID) {
      this.$emit('saveServiceID', serviceID)
    },
    /**
     * 引数に指定されたページが表示されているか。
     * 真の場合、文字を黒色太字とし、罫線を引くCSSクラス名を返却する。
     */
    setActivePageClass(pathname) {
      return pathname?.includes(location.pathname) ? 'nav-item-sub-active' : ''
    },
    /** お知らせのドロップダウンを表示後の処理 */
    async onShownInfoDropdown() {
      if (this.hasNewInfo) {
        await this.putInformation()
        // 取得し直す。
        this.info = await this.getInformation()
      }
    },
    /** お知らせ情報を既読にする。 */
    async putInformation() {
      try {
        const params = {
          companyId: this.company?.id,
          userId: this.userdata?.id,
          languageCode: this.userdata?.languageCode,
        }
        await this.$axios.put(
          `${this.$appConfig.CommonApiUrl}/userInfo`,
          params,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          },
        )
      } catch (error) {
        this.$toasted.show('データ登録エラーメッセージ')
      }
    },
  },
}
</script>

<style lang="scss">
// 注意：あえて`scoped`にしていません。同じ階層の`HeaderXXXX.vue`でここのSCSSを使用しています。

.header {
  border-top: 4px solid #73e000;
  border-bottom: 1px solid #ebebeb;
  min-height: $HEADER-HEIGHT;
  padding: 0 10px;

  .navbar-brand {
    display: flex;
    align-items: center;

    .sidebar-toggle-btn {
      width: 40px;
      height: 40px;
      margin-right: 10px;
      border: none;
      border-radius: 50%;

      background-color: transparent;
      &.is-open {
        background-color: #eeeeee;
        transition: 0.5s;
      }
      &:hover {
        background-color: #eeeeee;
        transition: 0.5s;
      }
    }

    .logo-img {
      height: 30px;
    }

    .client-title {
      display: contents;
      font-style: normal;
      font-weight: bold;
      font-size: 1.8rem;
      color: #515151;
    }
  }

  .navbar-collapse {
    // ドロップダウンに表示される場合、スクロールバーを表示する。
    overflow-y: auto;
    max-height: calc(100vh - #{$HEADER-HEIGHT});
    @include lg {
      // ナビゲーションバーに表示される場合、スクロールバーを非表示にする。
      overflow-y: unset !important;
      max-height: unset !important;
    }

    // メニュー項目
    .nav-item {
      transition: background-color 0.1s;
      &:hover {
        // ドロップダウンに表示される場合、ホバー時に背景色をつける。
        background-color: #f8f9fa;
        @include lg {
          // ナビゲーションバーに表示される場合、ホバー時に背景色をつけない。
          background-color: transparent;
        }
      }
    }

    // サブメニュー項目
    .nav-item-sub {
      // ドロップダウンに表示される場合、サブメニュー項目にインデントをつける。
      padding-left: 2rem;
      @include lg {
        // ナビゲーションバーに表示される場合、サブメニュー項目にはインデントをつけない。
        padding-left: unset;
      }
      > .nav-link {
        @include lg {
          // ナビゲーションバーに表示される場合、サブメニュー間のマージンをつける。
          margin-right: 2rem;
        }
      }

      // 現在表示されているページのサブメニュー項目
      &-active {
        // ドロップダウンに表示される場合、左側に罫線を表示する。
        border-left: 2px solid #73e000;
        padding-left: calc(2rem - 2px);
        @include lg {
          // ナビゲーションバーに表示される場合、左側に罫線を表示しない。
          border: unset;
          padding: unset;
        }

        > .nav-link {
          // 文字は黒色太字とする。
          font-weight: bold !important;
          color: #515151 !important;

          // ドロップダウンに表示される場合、下側に罫線を表示しない。
          border: unset;
          @include lg {
            // ナビゲーションバーに表示される場合、下側に罫線を表示する。
            border-bottom: 2px solid #73e000;
          }
        }
      }
    }
  }

  // ナビゲーション
  .nav {
    font-size: 1.4rem;
    .nav-link {
      color: rgba(0, 0, 0, 0.5);
    }
  }

  // メニュー項目
  .nav-item {
    font-size: 1.4rem;
    transition: color 0.1s;
    color: #6c757d;
    &:hover {
      color: #515151;
    }

    > .nav-link {
      white-space: nowrap;

      @include lg {
        // 7px(ヘッダーの罫線分)引く
        line-height: calc(#{$HEADER-HEIGHT} - 1rem - 7px);
      }

      & > img {
        transition: opacity 0.1s;
        &:hover,
        &:active,
        &:focus {
          opacity: 0.8;
        }
      }
    }
  }

  // ドロップダウンメニュー
  .dropdown-menu {
    box-shadow: 0px 2px 4px lightgray;
    font-size: 1.4rem;

    .dropdown-header {
      font-size: 1.4rem;
    }

    .dropdown-item {
      transition: color 0.1s;
      color: #6c757d;
      &:hover {
        color: #515151;
      }
      &:active {
        color: white;
      }
    }
  }

  &-right {
    align-items: center;
    gap: 1rem;

    // 画面サイズがmd以下の場合の右端の要素
    &-md {
      gap: 1rem;
      margin-right: 1rem;

      .nav-link {
        // 5px(ヘッダーの罫線分)引く
        line-height: calc(#{$HEADER-HEIGHT} - 1rem - 5px);
        padding: 0.5rem;
      }
    }
  }

  // お知らせ
  &-info {
    // "NEW"バッジ
    &-new {
      position: absolute;
      font-family: auto;
      color: white;
      background-color: red;
      transform: scale(0.7);
      padding: 4px 5px !important;
      top: 7px !important;
      right: -13px !important;
    }
    // メッセージ
    &-message {
      ul,
      ol {
        > li {
          list-style: unset;
        }
      }
      blockquote {
        border-left: 5px solid lightgray;
        padding-inline-start: 10px;
      }
    }
    > .dropdown-menu {
      overflow-x: hidden;
      overflow-y: auto;

      // できる限り大きく表示する。
      width: max-content;
      max-width: 90vw;
      max-height: 90vh;
      @include lg {
        // 固定サイズで表示する。
        width: 460px;
        max-height: 360px;
      }
    }
  }
}
</style>
